import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { AddCustomImage } from 'services/addBox'

export default function useSetCustomImage(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: { id: number; file: File }) => {
            return AddCustomImage(payload)
        },
        onSuccess: (data) => {
            toast.success('عکس صندوق با موفقیت تغییر یافت')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutateCustom: mutate }
}
